import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=2afc7d1a&scoped=true&"
import script from "./Collections.vue?vue&type=script&lang=js&"
export * from "./Collections.vue?vue&type=script&lang=js&"
import style0 from "./Collections.vue?vue&type=style&index=0&id=2afc7d1a&scoped=true&lang=css&"
import style1 from "./Collections.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc7d1a",
  null
  
)

export default component.exports